export enum CountryCodes {
  Canada = 'CA',
  USA = 'US',
  Mexico = 'MX'
}

export enum RegionCodes {
  Ontario = 'ON',
  BritishColumbia = 'BC'
}
